import Axios from "axios";
import JwtDecode from "jwt-decode";

function deleteToken() {
    localStorage.removeItem("token");
}

export default {
    namespaced: true,
    state: {
        token: localStorage.getItem("token") || null,
    },
    getters: {
        isLoggedIn: (state) => {
            return state.token !== null && state.userInfo !== null;
        },
        user: (state) => {
            const user = {
                id: null,
                username: null,
            };

            if (state.token) {
                try {
                    const decoded = JwtDecode(state.token);
                    user.id = decoded.id;
                    user.username = decoded.username;
                } catch (err) {
                    deleteToken();
                }
            }

            return user;
        },
    },
    mutations: {
        LOGOUT(state) {
            state.token = null;
            deleteToken();
        },
        SET_TOKEN(state, token) {
            localStorage.setItem("token", token);
            state.token = token;
            Axios.defaults.headers.common["Authorization"] = token;
        },
    },
    actions: {
        login({
            commit
        }, {
            username,
            password
        }) {
            return new Promise((resolve, reject) => {
                Axios.post("/auth/login", {
                        username,
                        password,
                    })
                    .then((res) => {
                        const {
                            data
                        } = res;
                        if (
                            data.success &&
                            data.success == true &&
                            data.data &&
                            data.data.token
                        ) {
                            commit("SET_TOKEN", data.data.token);
                        }
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        async refreshToken({
            commit
        }) {
            const {
                data
            } = await Axios.get("/auth/refresh-token");
            if (data.success && data.data && data.data.token) {
                commit("SET_TOKEN", data.data.token);
                return data.data.token;
            } else {

                if (data && !data.success && data.message) {
                    throw new Error(data.message);
                } else {
                    throw new Error('ไม่สามารถ refresh token ได้ กรุณาเข้าสู่ระบบใหม่อีกครั้ง');
                }

            }
        },
        async changePassword(context, payload = {
            password: '',
            newPassword: '',
            confirmPassword: ''
        }) {
            const {
                data
            } = await Axios.put('/auth/password', payload);
            return data;

        },
        logout({
            commit
        }) {
            Axios.post("/auth/logout");
            commit("LOGOUT");
        },
        clearToken({
            commit
        }) {
            commit("LOGOUT");
        },
    },
};